var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_535_9686)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.5 2.25C1.5 1.65326 1.73705 1.08097 2.15901 0.65901C2.58097 0.237053 3.15326 0 3.75 0C4.34674 0 4.91903 0.237053 5.34099 0.65901C5.76295 1.08097 6 1.65326 6 2.25C6 2.84674 5.76295 3.41903 5.34099 3.84099C4.91903 4.26295 4.34674 4.5 3.75 4.5C3.15326 4.5 2.58097 4.26295 2.15901 3.84099C1.73705 3.41903 1.5 2.84674 1.5 2.25ZM4.5 11.3297V14.3812L6.89062 16.7719C7.22344 17.1047 7.44375 17.5312 7.51875 17.9953L8.23125 22.2562C8.36719 23.0719 7.81406 23.8453 6.99844 23.9813C6.18281 24.1172 5.40938 23.5641 5.27344 22.7484L4.59844 18.7219L0.876563 15C0.314063 14.4375 0 13.6734 0 12.8766V8.74688C0 7.22813 1.22812 6 2.74687 6C3.87656 6 4.92656 6.5625 5.55469 7.5L7.55156 10.5H10.5C11.3297 10.5 12 11.1703 12 12C12 12.8297 11.3297 13.5 10.5 13.5H7.15313C6.40313 13.5 5.7 13.125 5.28281 12.4969L4.5 11.3297ZM0 22.5V16.2422L3 19.2422V22.5C3 23.3297 2.32969 24 1.5 24C0.670312 24 0 23.3297 0 22.5Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.5C9.67031 4.5 9 5.17031 9 6V10.5H10.5C11.3297 10.5 12 11.1703 12 12C12 12.8297 11.3297 13.5 10.5 13.5H16.5C17.3297 13.5 18 12.8297 18 12V6C18 5.17031 17.3297 4.5 16.5 4.5H10.5Z",
    fill: "#0270B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_535_9686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnload);
export default __webpack_public_path__ + "static/media/unload.2eccad5ecdd6ad6fb98cc6b9ce4770e8.svg";
export { ForwardRef as ReactComponent };